export default __webpack_public_path__ + "assets/ico_settings-39292c17.svg";